var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 2.08325H6.24996C5.69743 2.08325 5.16752 2.30275 4.77682 2.69345C4.38612 3.08415 4.16663 3.61405 4.16663 4.16659V20.8333C4.16663 21.3858 4.38612 21.9157 4.77682 22.3064C5.16752 22.6971 5.69743 22.9166 6.24996 22.9166H18.75C19.3025 22.9166 19.8324 22.6971 20.2231 22.3064C20.6138 21.9157 20.8333 21.3858 20.8333 20.8333V8.33325M14.5833 2.08325L20.8333 8.33325M14.5833 2.08325V8.33325H20.8333M12.5 18.7499V12.4999M9.37496 15.6249H15.625",
    stroke: "#656565",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePlus);
export default __webpack_public_path__ + "static/media/file-plus.26f25e3b36b6e495cf4b2fb9f69f6d3a.svg";
export { ForwardRef as ReactComponent };